import Vue from 'vue'
import Router from 'vue-router'


//行政业务 业务/////////////////.
const user_log = () => import("@/components/xz_list/person_log");
const persondutyclass = () => import("@/components/xz_list/person_duty_class");
const personduty = () => import("@/components/xz_list/person_duty");
const persondutynote = () => import("@/components/xz_list/person_duty_note");



Vue.use(Router)

//行政业务//////////////////////////
export default [

	{
		name: "xz_user_log",
		path: "/xz_user_log",
		component: user_log,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "个人日志"
		}
	},
	{
		name: "xz_ps_dutyclass",
		path: "/xz_ps_dutyclass",
		component: persondutyclass,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "值日项目"
		}
	},
	{
		name: "xz_ps_duty",
		path: "/xz_ps_duty",
		component: personduty,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "值日安排"
		}
	},
	{
		name: "xz_ps_dutynote",
		path: "/xz_ps_dutynote",
		component: persondutynote,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "值日备注"
		}
	}

]